import _ from "lodash";
import { SimpleScreen } from "../../controls/simpleScreen";
import { Component, ComponentOptions } from "./component";

const template = `
    <div id="#= data.id #" class="#: data.classes #">
        #= data.html #
    </div>
`;

export abstract class UserComponent extends Component {

    protected isLayout: boolean;
    protected view: Component;
    protected zScreen: any;

    constructor(viewFactory: () => Component, options: ComponentOptions) {
        super(options);
        this.view = viewFactory();
    }

    preRenderComponent() {
        super.preRenderComponent();

        this.zScreen = this.view.options.zScreen = new SimpleScreen({ name: this.options.screenName });
        this.view.contentRoot = this;
        this.view.recursiveDisable = this.recursiveDisable;
        this.view.router = this.router;
        this.view.options.screenEntityType = this.options.screenEntityType;

        this.view.preRenderComponent();
    }

    generate(): string {
        var kendoTemplate = kendo.template(template);
        var html = this.view.generate();
        var options = {
            id: this.options.id,
            classes: this.options.classes,
            html: html
        };
        var output = kendoTemplate(options);
        return output;
    }

    initComponent(): void {
        this.view.initComponent();
        super.initComponent();
    }

    destroyComponent(): void {
        super.destroyComponent();
        this.view.destroyComponent();
    }

    get(selector: string): JQuery {
        if (this.isLayout) {
            return super.get(selector);
        }
        return this.view.get(selector);
    }

}
